import React from 'react';
import { Mail, Phone, Clock, MapPin } from 'lucide-react';
import Newsletter from '../components/Newsletter';
import ContactForm from '../components/ContactForm';
import { contactInfo } from '../mock';

const Contact = () => {
  const items = [
    { Icon: Mail, label: 'Email', value: contactInfo.email },
    { Icon: Phone, label: 'Phone', value: contactInfo.phones.join('  ·  ') },
    { Icon: Clock, label: 'Hours', value: contactInfo.hours },
    { Icon: MapPin, label: 'Location', value: contactInfo.location },
  ];

  return (
    <div>
      <section className="pt-[140px] pb-12 px-6 lg:px-10">
        <div className="max-w-[1100px] mx-auto fade-up">
          <span className="dctv-eyebrow text-[#e8743b]">Contact</span>
          <h1 className="font-serif-dctv text-5xl md:text-6xl font-bold text-white mt-5">Get in touch</h1>
          <p className="text-[#bcc3cf] text-lg leading-relaxed mt-6 max-w-2xl">
            Questions, ideas or collaborations - reach out to the DCTV team. We would love to hear from you.
          </p>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-16">
        <div className="max-w-[1100px] mx-auto grid lg:grid-cols-2 gap-8">
          <div className="space-y-5">
            {items.map(({ Icon, label, value }) => (
              <div key={label} className="dctv-card rounded-2xl p-6 flex items-start gap-4">
                <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-[#e8743b]/12 flex-shrink-0">
                  <Icon className="w-5 h-5 text-[#e8743b]" />
                </span>
                <div>
                  <p className="dctv-eyebrow text-[#9aa3b2] text-[10px]">{label}</p>
                  <p className="text-white text-[15px] mt-1">{value}</p>
                </div>
              </div>
            ))}
          </div>
          <ContactForm />
        </div>
      </section>

      <Newsletter />
    </div>
  );
};

export default Contact;
